/**
 * StatisticsPaymentsMethod
 * --
 */
// import React from 'react';
import { Descriptions, Table, Button } from 'antd';
import { Content, Title, Row, Col } from 'components';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';
import { downloadXlsx } from 'utils/XlsxDownloader';
import Payment from 'constants/Payment';
/* 

결제수단별 매출 : 사용중인 필드
  payment_type: 결제수단
  totalAmount: 합계금액
  netSales: 순매출
  paymentsCount: 판매수량
  couponAppliedCount: 쿠폰사용수량
  discountAmount: 쿠폰사용금액
*/

/**----------------------------------------
 * [Component] 메뉴별 매출
 * ----------------------------------------
 */
const StatisticsPaymentsMethod = ({
  // shopList, // 업체목록
  // currentShop, // 선택된 업체 키
  data, // 차트 데이터
  startDate,
  endDate,
  dateRange,
  finalDiscount,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  // const currentShopInfo = shopList.filter(({ key }) => key === currentShop)[0];
  /**
   * 상위 컬럼
   * --
   */
  const columns = [
    {
      title: '결제수단',
      dataIndex: 'payment_type',
      width: '10%',
      fixed: 'left',
      filters: [
        { text: 'KIOSK', value: 'KIOSK' },
        { text: 'APP', value: 'APP' },
        { text: 'POS', value: 'POS' },
      ],
      onFilter: (value, { payment_type }) => payment_type.includes(value),
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          Total
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출+할인+환불+포인트)
          </span>
        </span>
      ),
      dataIndex: 'total',
      width: '16%',
      render: (v, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(
            Number(record.totalAmount) + Number(record.refundAmount ?? 0)
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aTotal = Number(a.totalAmount) + Number(a.refundAmount ?? 0);
        const bTotal = Number(b.totalAmount) + Number(b.refundAmount ?? 0);
        return aTotal - bTotal;
      },
    },
    {
      title: '총매출',
      dataIndex: 'totalAmount',
      width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.totalAmount - b.totalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출-할인-포인트)
          </span>
        </span>
      ),
      dataIndex: 'completedTotalAmount',
      width: '14%',
      render: (v, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(record.completedTotalAmount))}
        </div>
      ),
      sorter: (a, b) => a.completedTotalAmount - b.completedTotalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          결제건수
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (결제완료건)
          </span>
        </span>
      ),
      dataIndex: 'paymentsCount',
      width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.paymentsCount - b.paymentsCount,
    },
    {
      title: '환불금액',
      dataIndex: 'refundAmount',
      width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.refundAmount - b.refundAmount,
    },
    {
      title: '환불건수',
      dataIndex: 'refundCount',
      width: '8%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.refundCount - b.refundCount,
    },
    {
      title: '할인',
      dataIndex: 'discountAmount',
      width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.discountAmount - b.discountAmount,
    },
    {
      title: '사용포인트',
      dataIndex: 'usePointAmount',
      width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.usePointAmount - b.usePointAmount,
    },
    {
      title: (
        <span>
          쿠폰적용
          <br />
          주문수
        </span>
      ),
      dataIndex: 'couponAppliedCount',
      width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.couponAppliedCount - b.couponAppliedCount,
    },
  ];
  /**
   * 상세 컬럼
   * --
   */
  const expandableColumns = [
    {
      title: '결제수단',
      dataIndex: 'payment_type',
      width: '10%',
      fixed: 'left',
      filters: Object.entries(Payment.PAYMENT_METHOD).map(([key, value]) => ({
        text: value,
        value: key,
      })),
      onFilter: (value, { payment_type }) => payment_type.includes(value),
      render: (payment_type) => Payment.PAYMENT_METHOD[payment_type],
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          Total
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출+할인+환불+포인트)
          </span>
        </span>
      ),
      dataIndex: 'total',
      // width: '14%',
      render: (v, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(
            Number(record.totalAmount) + Number(record.refundAmount ?? 0)
          )}
        </div>
      ),
      sorter: (a, b) => {
        const aTotal = Number(a.totalAmount) + Number(a.refundAmount ?? 0);
        const bTotal = Number(b.totalAmount) + Number(b.refundAmount ?? 0);
        return aTotal - bTotal;
      },
    },
    {
      title: '총매출',
      dataIndex: 'totalAmount',
      // width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.totalAmount - b.totalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          순매출
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (총매출-할인-포인트)
          </span>
        </span>
      ),
      dataIndex: 'completedTotalAmount',
      // width: '14%',
      render: (v, record) => (
        <div style={{ textAlign: 'right' }}>
          {stringToMoneyFormat(Number(record.completedTotalAmount))}
        </div>
      ),
      sorter: (a, b) => a.completedTotalAmount - b.completedTotalAmount,
    },
    {
      title: (
        <span style={{ lineHeight: 0.5 }}>
          결제건수
          <br />
          <span style={{ fontSize: '0.8em', color: '#7f7f7f' }}>
            (결제완료건)
          </span>
        </span>
      ),
      dataIndex: 'paymentsCount',
      // width: '8%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.paymentsCount - b.paymentsCount,
    },
    {
      title: '환불금액',
      dataIndex: 'refundAmount',
      // width: '14%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.refundAmount - b.refundAmount,
    },
    {
      title: '환불건수',
      dataIndex: 'refundCount',
      // width: '8%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.refundCount - b.refundCount,
    },
    {
      title: '할인',
      dataIndex: 'discountAmount',
      // width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.discountAmount - b.discountAmount,
    },
    {
      title: '사용포인트',
      dataIndex: 'usePointAmount',
      // width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.usePointAmount - b.usePointAmount,
    },
    {
      title: (
        <span>
          쿠폰적용
          <br />
          주문수
        </span>
      ),
      dataIndex: 'couponAppliedCount',
      // width: '10%',
      render: (v) => (
        <div style={{ textAlign: 'right' }}>{stringToMoneyFormat(v)}</div>
      ),
      sorter: (a, b) => a.couponAppliedCount - b.couponAppliedCount,
    },
  ];

  /* ===== FUNCTION ===== */
  const handleCalculate = (d, key) => {
    return d.reduce((acc, cur) => acc + Number(cur[key]), 0);
  };
  /**
   * 엑셀 다운로드
   * --
   */
  const handleDownload = () => {
    const col = [
      {
        title: '주문경로',
        dataIndex: 'order_route',
      },
      ...columns?.map((column) => {
        if (typeof column.title !== 'string') {
          column.title = column?.title?.props.children
            .map((child) =>
              typeof child === 'string' ? child : child.props?.children || ''
            )
            .join(' ');
        }
        return column;
      }),
    ];

    const rows = data?.flatMap((_item) => {
      return _item?.payment_method_list?.map((_method_list) => {
        return {
          order_route: _item.payment_type,
          payment_type: _method_list.payment_type,
          total: _method_list.total || 0,
          totalAmount: _method_list.totalAmount || 0,
          completedTotalAmount: _method_list.completedTotalAmount || 0,
          discountAmount: _method_list.discountAmount || 0,
          paymentsCount: _method_list.paymentsCount || 0,
          couponAppliedCount: _method_list.couponAppliedCount || 0,
          refundCount: _method_list.refundCount || 0,
          refundAmount: _method_list.refundAmount || 0,
          usedPointAmount: _method_list.usedPointAmount || 0,
        };
      });
    });

    downloadXlsx({
      columns: col,
      rows: rows,
      fileName: '결제수단별리포트',
    });
  };

  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */

  return (
    <>
      <Content maxWidth={'100%'} padding={0} backgroundColor={'none'}>
        <Row>
          {/* === 상단 > 타이틀 === */}
          <Col x={12} style={{ display: 'flex', gap: 10 }}>
            <Title style={{ marginBottom: 7.5 }}>
              결제수단별 리포트
              {/* {currentShopInfo && `(${currentShopInfo.shop_information_name})`} */}
            </Title>
            <Button onClick={() => handleDownload()}>엑셀로 다운로드</Button>
          </Col>
          <Col x={12} style={{ textAlign: 'right' }}>
            <Title
              level={5}
              align="right"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                marginBottom: 7.5,
              }}
            >
              <small>조회기간:</small>&nbsp;&nbsp;
              {!dateRange.startDate || !dateRange.endDate ? (
                <>
                  {moment(startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(endDate).format('YYYY.MM.DD(ddd)')}
                </>
              ) : (
                <>
                  {moment(dateRange.startDate).format('YYYY.MM.DD(ddd)')}~
                  {moment(dateRange.endDate).format('YYYY.MM.DD(ddd)')}
                </>
              )}
            </Title>
          </Col>
        </Row>
        <div style={{ background: '#fff' }}>
          {data && (
            <Descriptions
              className="boxShadow"
              // title="User Info"
              size="small"
              layout="vertical"
              column={10}
              bordered
              style={{ width: '100%', overflowX: 'scroll' }}
              contentStyle={{ textAlign: 'right' }}
              items={[
                {
                  key: 'date',
                  label: '',
                  contentStyle: { textAlign: 'center' },
                  style: { width: '5%' },
                  children: <p>합계</p>,
                },
                {
                  key: 'total',
                  label: 'Total',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmount') +
                          handleCalculate(data, 'refundAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'totalAmount',
                  label: '총매출',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'totalAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'completedTotalAmount',
                  label: '순매출',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'completedTotalAmount')
                        // Math.abs(handleCalculate(data, 'discountAmount'))
                      )}
                    </p>
                  ),
                },
                {
                  key: 'paymentsCount',
                  label: '결제건수',
                  style: { width: '7%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'paymentsCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundAmount',
                  label: '환불금액',
                  style: { width: '14%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'refundCount',
                  label: '환불건수',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'refundCount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'discountAmount',
                  label: '할인금액',
                  style: { width: '9%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'discountAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'usePointAmount',
                  label: (
                    <>
                      <p>사용</p>
                      <p>포인트</p>
                    </>
                  ),
                  style: { width: '7%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'usePointAmount')
                      )}
                    </p>
                  ),
                },
                {
                  key: 'couponAppliedCount',
                  label: (
                    <>
                      <p>쿠폰적용</p>
                      <p>주문수</p>
                    </>
                  ),
                  style: { width: '7%' },
                  children: (
                    <p>
                      {stringToMoneyFormat(
                        handleCalculate(data, 'couponAppliedCount')
                      )}
                    </p>
                  ),
                },
              ]}
            />
          )}
        </div>
        <br />

        <div style={{ overflow: 'auto', width: '100%', height: '100%' }}>
          <Table
            // style={{ minWidth: 1500 }}
            className="boxShadow"
            bordered
            size="small"
            dataSource={data ?? []}
            columns={columns}
            scroll={{
              x: 'max-content',
            }}
            rowKey="payment_type"
            onRow={(record) => {
              return {
                style: {
                  borderBottom: '1px solid #000', // 행의 아래쪽에만 테두리 추가
                  transition: 'none', // 호버 효과 없애기
                  fontWeight: 'bold', // 텍스트 굵게
                },
              };
            }}
            expandable={{
              expandedRowRender: (rw) => {
                return (
                  <Table
                    columns={expandableColumns}
                    // dataSource={result}
                    dataSource={rw?.payment_method_list}
                    pagination={false}
                    rowKey="payment_type"
                    scroll={{
                      x: 'max-content',
                    }}
                  />
                );
              },
              // defaultExpandedRowKeys: ['1', '2', '3'],
              // expandedRowKeys: newDataList?.menus?.map((item) => item?.key),
            }}
            style={{ minHeight: 580 }}
          />
        </div>
      </Content>
    </>
  );
};

export default StatisticsPaymentsMethod;
